
export default function StatsSection() {
  return (
    <section className="bg-[#1A3A22] relative overflow-hidden py-20 lg:py-24">
      {/* Dot texture */}
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{ backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '28px 28px' }}
      />

      {/* Left accent line */}
      <div className="absolute left-0 top-0 w-1 h-full bg-[#2D7F3E]" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">

        {/* Opening quote mark */}
        <div className="font-serif text-[#5EC97A] opacity-40 leading-none mb-6 select-none" style={{ fontSize: '8rem', lineHeight: '1' }}>
          &ldquo;
        </div>

        <blockquote
          className="font-serif text-white leading-relaxed mb-8"
          style={{ fontSize: 'clamp(1.35rem, 2.8vw, 2rem)' }}
        >
          The future belongs to those who learn more skills and combine them in creative ways.
        </blockquote>

        <div className="flex items-center justify-center gap-4">
          <div className="w-10 h-px bg-[#5EC97A]" />
          <cite className="not-italic text-[#5EC97A] text-sm font-semibold tracking-wider uppercase">
            Robert Greene
          </cite>
          <div className="w-10 h-px bg-[#5EC97A]" />
        </div>

      </div>
    </section>
  );
}
